function enableZoomOnHover(zoomRatio) {
  const LENS_SIZE = 180;
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    let lens = null;
    let fullSrc = '';

    function createLens() {
      lens = document.createElement('div');
      lens.className = 'magnify-lens';
      lens.style.cssText =
        'position:absolute;width:' + LENS_SIZE + 'px;height:' + LENS_SIZE + 'px;' +
        'border-radius:50%;border:3px solid rgba(255,255,255,0.85);' +
        'box-shadow:0 4px 20px rgba(0,0,0,0.25);pointer-events:none;' +
        'background-repeat:no-repeat;opacity:0;transition:opacity 0.15s ease;' +
        'z-index:10;display:none;';

      // Use the highest resolution available
      fullSrc = image.currentSrc || image.src;
      // Request the full-size image from Shopify CDN
      fullSrc = fullSrc.replace(/&width=\d+/, '').replace(/\?width=\d+&?/, '?');

      lens.style.backgroundImage = 'url(' + fullSrc + ')';

      // Make sure the parent is positioned
      var parent = image.closest('.product__media') || image.parentElement;
      if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent.appendChild(lens);

      // Once full image loads, set the background size
      var fullImg = new Image();
      fullImg.onload = function () {
        lens.dataset.fullWidth = fullImg.naturalWidth;
        lens.dataset.fullHeight = fullImg.naturalHeight;
      };
      fullImg.src = fullSrc;
    }

    function moveLens(e) {
      if (!lens) return;

      var rect = image.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      // Keep lens within image bounds
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        lens.style.opacity = '0';
        return;
      }

      // Position lens centered on cursor
      var parent = lens.parentElement;
      var parentRect = parent.getBoundingClientRect();
      var lensX = e.clientX - parentRect.left - LENS_SIZE / 2;
      var lensY = e.clientY - parentRect.top - LENS_SIZE / 2;
      lens.style.left = lensX + 'px';
      lens.style.top = lensY + 'px';
      lens.style.display = 'block';
      lens.style.opacity = '1';

      // Calculate background position for zoom
      var xRatio = x / rect.width;
      var yRatio = y / rect.height;

      var bgWidth = rect.width * zoomRatio;
      var bgHeight = rect.height * zoomRatio;
      lens.style.backgroundSize = bgWidth + 'px ' + bgHeight + 'px';

      var bgX = -(xRatio * bgWidth - LENS_SIZE / 2);
      var bgY = -(yRatio * bgHeight - LENS_SIZE / 2);
      lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    }

    function handleEnter(e) {
      if (!lens) createLens();
      moveLens(e);
    }

    function handleLeave() {
      if (lens) {
        lens.style.opacity = '0';
        lens.style.display = 'none';
      }
    }

    // Attach to the modal-opener or parent that covers the image area
    var hoverTarget = image.closest('.product__modal-opener') || image.parentElement;

    hoverTarget.addEventListener('mouseenter', handleEnter);
    hoverTarget.addEventListener('mousemove', moveLens);
    hoverTarget.addEventListener('mouseleave', handleLeave);
  });
}

enableZoomOnHover(1.8);
